import { withFormik } from 'formik';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { extractValidationErrors } from 'src/app/popsicle/utils';
import { patchDeliveryAddress, updateContactInfo } from 'src/app/state/actions';
import { pushNextCheckoutState, setCheckoutContactInfo } from 'src/app/state/actions/checkout';
import { getBFFCartDeliveryAddress, getCurrentAccountId } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import type { ContactInfo } from 'src/app/types';

import validation from './validation';

import { CheckoutContactInfoRenderer } from '.';

const mapStateToProps = (state: RootState) => {
  const accountId = getCurrentAccountId(state);
  const deliveryAddressId = getBFFCartDeliveryAddress(state)?.id;

  return {
    accountId,
    deliveryAddressId,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchContactInfo: (contactInfo: ContactInfo) => {
    contactInfo.phone = contactInfo.phone.replace(/-/g, '');
    dispatch(updateContactInfo(contactInfo));
  },
  dispatchSuccessRedirect: async (deliveryAddressId: string, name: string) => {
    dispatch(setCheckoutContactInfo());
    dispatch(patchDeliveryAddress(deliveryAddressId, name));
    await dispatch(pushNextCheckoutState());
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

const enhancedWithFormik = withFormik({
  displayName: 'CheckoutContactInfoForm',
  enableReinitialize: true,
  mapPropsToValues: () => {
    const initialValues = validation.initialValues;
    return { ...initialValues };
  },
  validationSchema: validation.schema,
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: async (values, { props, setErrors, setSubmitting }) => {
    const { first_name, last_name, phone } = values;
    const { accountId, deliveryAddressId, dispatchContactInfo, dispatchSuccessRedirect } = props as any;
    setSubmitting(true);

    try {
      const name = `${first_name} ${last_name}`;
      await dispatchContactInfo({ accountId, firstName: first_name, lastName: last_name, phone });
      setSubmitting(false);
      await dispatchSuccessRedirect(deliveryAddressId, name);
      return;
    } catch (error) {
      setErrors(extractValidationErrors(error));
      setSubmitting(false);
    }
  },
});

export const CheckoutContactInfo = compose(connector, enhancedWithFormik)(CheckoutContactInfoRenderer);
